import { createSingleEntityStore } from '@core/ngrx-legacy';
import { SkillEntity } from '@core/tellent-skills-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<SkillEntity>()(
  'Skills',
  {
    customActions: adapter => ({
      fetchAvailableSkills: (state: ReturnType<typeof adapter.markAsPending>) =>
        adapter.markAsPending(state),
      fetchAvailableSkillsSuccess: (state, payload: { data: SkillEntity }) =>
        adapter.markAsLoaded(adapter.save(state, payload.data)),
      fetchAvailableSkillsFailed: (state, payload: { error: unknown }) =>
        adapter.setError(state, payload.error),
    }),
  },
);

export {
  selectors as SkillsSelectors,
  reducer as SkillsReducer,
  actions as SkillsActions,
  namespace as SkillsNamespace,
};
